import styled from 'styled-components';

export const StepPatientSC = styled.div`
  grid-area: content;

  .header {
    margin: 40px 0;
    font-weight: 1000;
    font-size: 30px;
  }

  .subheader {
    font-weight: 1000;
    font-size: 20px;
    line-height: 30px;
    margin-left: 34px;
    margin-bottom: 40px;
  }

  .box {
    margin-bottom: 40px;
    h3 {
      margin-bottom: 20px;
      font-weight: 1000;
    }

    p {
      font-size: 17px;
      line-height: 25px;
      margin-left: 34px;
      margin-bottom: 0;
      color: #fff;
    }

    .team-hilbi {
      display: block;
      margin-left: 34px;
      margin-top: 20px;
      font-weight: bold;
    }
  }

  .download-app-copy {
    margin-top: 40px;
    margin-bottom: 25px;
    margin-left: 34px;
  }

  .links {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;

    img {
      width: 270px;
    }

    img:first-child {
      margin-bottom: 20px;
    }
  }

  h1,
  h3,
  p,
  span {
    color: #fff;
  }

  @media (min-width: 900px) {
    padding: 5% 8%;
    display: flex;
    flex-direction: column;

    .links {
      flex-direction: row;
    }

    .header {
      font-size: 40px;
      margin-left: 34px;
    }

    .subheader {
      font-size: 25px;
    }

    .box {
      p {
        font-size: 20px;
      }
    }
  }
`;
